import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objNgFor'
})
export class ObjNgForPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/pipes/objNgFor/objNgFor.pipe.ts